module.exports = __webpack_public_path__ + "img/icon-copy.8753227b.svg";